import React from 'react';
import { Card, CardTheme, CardHeaderTheme, CardBorderRadius, CardBorderStyle, Button, ButtonTheme } from '@apply/components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBuildingUser } from '@fortawesome/free-solid-svg-icons';
import { CompanyLogoFileUpload } from './components/CompanyLogoFileUpload';
import { useCompanyBrandingValidation } from './hooks/useCompanyBrandingValidation';
import { useBrokerCompanyBrandingSubmit } from './hooks/useBrokerCompanyBrandingSubmit';
import { useBrokerDetailsStore } from '../../../state/brokerDetailsStore';
export const CompanyBrandingPanel: React.FC = () => {
    const companyLogoFile = useBrokerDetailsStore((s) => s.companyLogoFile);
    const companyLogoUrl = useBrokerDetailsStore((s) => s.companyLogoUrl);
    const uploadFileEnabled = companyLogoFile;
    const { validate } = useCompanyBrandingValidation();
    const submit = useBrokerCompanyBrandingSubmit(validate);

    const cardHeader = () => {
        return (
            <>
                <div className='brokerSettingsCardHeader'>
                    <FontAwesomeIcon
                        icon={faBuildingUser}
                        className='icon'
                        style={{ paddingRight: '10px' }}
                    />
                    <h4>Company Information</h4>
                </div>
            </>
        );
    };

    return (
        <>
            <div className='brokerSettingsCompanyBrandingPanel'>
                <Card
                    theme={CardTheme.White}
                    headerTheme={CardHeaderTheme.Gray}
                    borderStyle={CardBorderStyle.SolidDarkerBorder}
                    borderRadius={CardBorderRadius.Small}
                    header={cardHeader()}
                    collapsible={true}
                >
                    <div style={{ paddingBottom: companyLogoUrl ? '0px' : '20px' }}>
                        <CompanyLogoFileUpload />
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                        <Button
                            id='updateCompanyLogoButton'
                            theme={ButtonTheme.Primary}
                            width='200px'
                            height='42px'
                            disabled={!uploadFileEnabled}
                            handleClick={() => submit.handleUploadCompanyLogo()}
                            visible={!companyLogoUrl}
                        >
                            Upload File
                        </Button>
                    </div>
                </Card>
            </div>
        </>
    );
};
